<template>
  <div>
    <mdb-card class="card-image image">
      <div class="text-white text-center rgba-stylish-strong py-0 px-4">
        <div class="py-5">
          <h2 class="h2 orange-text"><mdb-icon icon="project-diagram" /> Networking</h2>
        </div>
      </div>
    </mdb-card>
    <div>
      <mdb-container>
        <mdb-row>
          <mdb-col>
            <h1 class="h2 my-4 text-center">
              Structured Cabling
            </h1>
          </mdb-col>
        </mdb-row>
        <div>
          <p>
            Structured Cabling is the installation of standardized cabling systems that are designed to carry data, video and voice signals in a residential or commercial environment.Hypertech IT Consultants specializes in the design, preparations of structured cabling specifications and installation of structured cabling systems with an emphasis on new construction and corporate relocations. Whether your network is ten computers or ten buildings in a campus environment, we can provide the copper and optic fiber cabling needed to connect voice and data across the Local Area Networks (LAN) and Wide Area Networks (WAN).Our cabling installation team is experienced in designing systems for a wide range of buildings and equipment types, with an understanding of the environment and aesthetic issues required.We offer a complete Network Cabling installation service utilizing:
            <ul>
              <li>Unshielded Twisted Pair (UTP)</li>
              <li>Shielded Twisted Pair (STP)</li>
              <li>Fibre Optic Systems.</li>
            </ul>
          </p>
        </div>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbCol from 'mdbvue/lib/components/mdbCol'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbRow from 'mdbvue/lib/components/mdbRow'

export default {
  name: 'Networking',
  components: {
    mdbCard,
    mdbIcon,
    mdbContainer,
    mdbCol,
    mdbRow
  }
}
</script>

<style scoped>
.image {
  background: url("~@/assets/networking.jpeg");
}
</style>
